export default __webpack_public_path__ + "./images/gh.24b83e85.png";